import React from "react";
import { Search, FileSearch, Wrench, ClipboardCheck, BadgeCheck } from "lucide-react";

const steps = [
  {
    icon: Search,
    n: "01",
    title: "Diagnóstico inicial",
    desc: "Visita técnica o reporte remoto. Identificamos fallas, capacidad y prioridad.",
  },
  {
    icon: FileSearch,
    n: "02",
    title: "Cotización detallada",
    desc: "Propuesta clara con alcance, tiempos, repuestos y normativa aplicable.",
  },
  {
    icon: Wrench,
    n: "03",
    title: "Ejecución técnica",
    desc: "Intervención por técnicos certificados, con trazabilidad por etapa.",
  },
  {
    icon: ClipboardCheck,
    n: "04",
    title: "Pruebas y entrega",
    desc: "Pruebas TTR, megger, hipot, polaridad. Reporte firmado y certificado.",
  },
  {
    icon: BadgeCheck,
    n: "05",
    title: "Garantía y soporte",
    desc: "Acompañamiento post-entrega, mantenimientos programados y soporte 24/7.",
  },
];

export default function Process() {
  return (
    <section
      id="proceso"
      data-testid="process-section"
      className="relative py-24 lg:py-32 bg-[#0a0a0a]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="mb-16 max-w-3xl">
          <div className="text-[11px] uppercase tracking-[0.3em] text-[#ff6b00] mb-4 flex items-center gap-3">
            <span className="w-8 h-px bg-[#ff6b00]" />
            <span>Proceso · 05 fases</span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter">
            Así trabajamos.<br />
            <span className="text-[#a0aabf]">Sin sorpresas. Sin demoras.</span>
          </h2>
        </div>

        <div className="relative">
          <div className="absolute top-12 left-0 right-0 h-px bg-white/5 hidden lg:block" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-px bg-white/5 border border-white/5">
            {steps.map((s, i) => (
              <div
                key={s.n}
                data-testid={`process-step-${s.n}`}
                className="bg-[#0a0a0a] hover:bg-[#12141a] p-6 lg:p-7 transition-colors group"
              >
                <div className="flex items-center justify-between mb-6">
                  <span className="font-mono text-xs text-[#a0aabf]">/{s.n}</span>
                  <s.icon className="w-5 h-5 text-[#ff6b00] group-hover:scale-110 transition-transform" strokeWidth={1.5} />
                </div>
                <h3 className="font-display text-lg font-semibold mb-3 leading-snug">
                  {s.title}
                </h3>
                <p className="text-xs text-[#a0aabf] leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
